import { gql } from '@apollo/client'
import { useMutation } from '../useMutation'
import { useError } from '../useError'
import { useEffect, useState } from 'react'

const mutationQuery = gql(`mutation generateAppServiceToken($input: JSON!) {
  generateAppServiceToken(input: $input)
}`)

/**
 * This is a special token, it used on several services and expires for 10days
 * It has also some limited access to Order.canView and Order.canEdit only
 */
export const useServiceAccessToken = ({ tokenName, serviceName }: { tokenName: string; serviceName: string }) => {
  const [, generateServiceToken, { error }] = useMutation({
    query: mutationQuery,
    options: {
      mutationOptions: {
        variables: {
          input: {
            tokenName,
            serviceName,
          },
        },
      },
    },
  })

  //show the error on the user if there is any
  useError(error)
  const [accessToken, setAccessToken] = useState(null)

  //we call this generate service token one time
  useEffect(() => {
    generateServiceToken().then((res) => {
      const resultToken = res?.data?.generateAppServiceToken
      if (resultToken) setAccessToken(resultToken)
    })
  }, [])

  return accessToken
}

export const useOrderServiceAccessToken = () => {
  return useServiceAccessToken({ tokenName: 'order', serviceName: 'ORDER_APP_SERVICE_USER' })
}

export const usePurchaseOrderServiceAccessToken = () => {
  return useServiceAccessToken({ tokenName: 'purchaseOrder', serviceName: 'PURCHASE_ORDER_APP_SERVICE_USER' })
}
